import { Card, makeStyles, Text, tokens } from '@fluentui/react-components';
import { useNavigate } from 'react-router-dom';

export default function TemplateItem(props: { id: string; title: string }) {
	const navigate = useNavigate();
	const classes = useStyles();

	return (
		<Card
			className={classes.root}
			onClick={() => {
				navigate('/automation-rule?template-id=' + props.id);
			}}
		>
			<Text as='p' className={classes.title}>
				{props.title}
			</Text>
		</Card>
	);
}

const useStyles = makeStyles({
	root: {
		display: 'flex',
		flexDirection: 'column',
		gap: '16px',
		padding: '16px',
		maxWidth: '360px',
	},
	title: {
		fontFamily: tokens.fontFamilyBase,
		fontSize: tokens.fontSizeBase300,
		fontWeight: tokens.fontWeightRegular,
		lineHeight: tokens.lineHeightBase300,
		color: tokens.colorNeutralForeground1,
	}
});